import { useUnifiedDetailsV1 } from './useUnifiedDetailsV1';
import { useUnifiedDetailsV2 } from './useUnifiedDetailsV2';
// We will continue to use this centralized useUnifiedDetails hook
// to alias the expected version bumps (V1, V2, V3, etc.)
// until things stabilize for release
export function useUnifiedDetails({
  appContext = 'app',
  slug,
  language,
  skip,
  version = 2
}) {
  const responseV2 = useUnifiedDetailsV2({
    appContext,
    slug,
    language,
    skip: skip || version !== 2
  });
  const responseV1 = useUnifiedDetailsV1({
    appContext,
    slug,
    language,
    skip: skip || version !== 1
  });
  if (version === 1) {
    return responseV1;
  }
  return responseV2;
}